import React from "react";
import ReactDOM from "react-dom";
import MovementsTable from "./components/MovementsTable";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { findCompanyMovements } from "../../infrastructure/repository/movements-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export function renderMovementsTable({ ...props }) {
  const target = document.getElementById("table-movements-container");

  if (target) {
    ReactDOM.render(<MovementsTable {...props} />, target);
  }
}

export async function displayMovements() {
  try {
    renderMovementsTable({ movements: [], isLoading: true });
    const companyId = await findCompanyId();
    const { data } = await findCompanyMovements({ companyId });
    const { movements } = data;
    addContextLog("info", "displayMovements", "display-screen", { movements });
    renderMovementsTable({ movements });
  } catch (e) {
    logError(e, "Error to displayMovements");
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
